import { IUserRoleStrings } from "@/types/interfaces/user";

export const fullQuoteAccessRoles: IUserRoleStrings[] = [
  "admin",
  "agent",
  "ezlynx",
  "agencyAdmin",
  "subAdmin",
  "underwriting",
  "claims",
  "billing",
  "dataEntry"
];

export const baseMeta = {
  requireAuth: true
};

export const metaWithRoles = {
  ...baseMeta,
  allowedRoles: fullQuoteAccessRoles
};
